module.exports = __webpack_public_path__ + "images/icon/search_navy_54-cb369a97.svg";